module.exports = __webpack_public_path__ + "img/tall-processing.78e68e59.gif";